import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './index.module.less';
export const Faq = ({ title, children }) => {
    return (_jsxs("section", { className: styles.section, children: [_jsx("h2", { className: styles.title, children: _jsx("span", { className: styles.text, children: title }) }), _jsx("div", { className: styles.content, children: children })] }));
};
